<template>
  <div class="Freequote-main">
    <div class="Science-btn">
      <area-cascader  :level="1" type="text" :placeholder="cidata" v-model="city" :data="pcaa" @change="getChangeVal"></area-cascader>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { pca, pcaa } from 'area-data'; // 城市数据
import 'vue-area-linkage/dist/index.css'; // 样式
export default {
  components: {
    
  },
  // props: ["cidatas"],
  // watch: {
  //   cidatas: "getcidatas"
  // },
  data(){
    return{
        pcaa:pcaa,
        valCity:'',
        areaCascader:'',
        city:[],
        cidata:'请选择省市区'
    }
  },
  methods:{
   getChangeVal(){
     //console.log('ci',this.city);
     this.$emit('citydata',this.city)
   },
  //  getcidatas(){
  //    if(this.cidatas.province == undefined){
  //      return false
  //    }else{
  //       this.cidata = this.cidatas.province +'/'+this.cidatas.city +'/'+this.cidatas.area
  //    }
  //  }
  }
}
</script>
<style scoped>
.Freequote-title {
  width: 100%;
  color: #b31d25;
  font-size: 30px;
  margin-top: 20px;
  margin-bottom: 20px;
}
>>>.area-select{
  height: 40px !important;
  line-height: 25px;  
}
.Science-btn {
  width: 100%;
  height: 100%;
    /* height: 1rem; */
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px;
    /* padding-top: 17px; */
}
.Science-btn ul {
  overflow: hidden;
  padding-inline-start: 0px;
}
.Science-btn ul li {
  list-style: none;
  width: 120px;
  float: left;
  margin-left: 20px;
}

</style>
